module.exports = __webpack_public_path__ + "img/offer_mobile.16f5d4ca.webp";